<template>
  <div v-show="showOverlay">
    <div class="unauthorized-feature-wrapper">
      <div class="unauthorized-feature-bar">
        <diamond-icon class="icon" title="Alerta"></diamond-icon>
        Seu plano não comporta essa funcionalidade. Você pode alterar seu plano a qualquer hora!
        <a href="/v2.html#/payment">Clique aqui para atualizar seu plano</a>
      </div>
    </div>

    <div class="unauthorized-feature-overlay" v-show="true">
      <div class="content">
        Assine o
        <a href="/v2.html#/payment" id="plan-name">Plano {{ planName }}</a>
        para ter acesso a esta solução!
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import DiamondIcon from 'vue-material-design-icons/DiamondStone';
import {
  RANKING_RESELLER_BRONZE,
  RANKING_RESELLER_SILVER,
  RANKING_RESELLER_GOLD,
  RANKING_RESELLER_BLACK,
  RANKING_RESELLER_DIAMOND,
} from '../../../../../../components/Redirect360/rankingResellerEnums';

export default {
  components: {
    DiamondIcon,
  },
  name: 'UnauthorizedFeaturePDV',
  computed: {
    ...mapState('subscription', ['subscription']),
  },
  mounted() {
    this.checkPlanName();
  },
  data() {
    return {
      showOverlay: true,
      planName: 'Clipp360',
      isPlan360: false,
      clipp360SubscriptionId: 25,
      ordemClipp360SubscriptionId: 26,
      clippReseller: 7,
      clippTrialId: 6,
      rankingResellerPermited: [
        RANKING_RESELLER_BLACK,
        RANKING_RESELLER_DIAMOND,
        RANKING_RESELLER_GOLD,
        RANKING_RESELLER_SILVER,
        RANKING_RESELLER_BRONZE,
      ],
    };
  },
  methods: {
    ...mapActions('subscription', ['setSubscription']),
    async checkPlanName() {
      let { paymentMode } = this.subscription || { paymentMode: null };

      if (!paymentMode) {
        paymentMode = (await this.setSubscription()).paymentMode;
      }

      const { id: subscriptionId } = paymentMode;

      this.isPlan360 =
        this.clipp360SubscriptionId === subscriptionId ||
        this.ordemClipp360SubscriptionId === subscriptionId ||
        this.clippTrialId === subscriptionId ||
        this.clippReseller === subscriptionId;

      if (this.isPlan360 && window.location.origin === process.env.VUE_APP_BASE_URL_360) {
        this.showOverlay = false;
      }
    },
  },
};
</script>
